import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import { modules } from '@/store/modules';
import { LOCAL_STORAGE_STATE_PERSIST } from '@/utils/constants/checkin.constants';

import resetStates from './resetStates';
import resetStatesVuexPersist from './resetStatesVuexPersist';

Vue.use(Vuex);

/**
 * INFO: Vuex custom key LOCAL_STORAGE_STATE_PERSIST
 * string must be updated in BREAKING CHANGE case
 **/
const vuexPersist = new VuexPersistence({
  storage: localStorage,
  key: LOCAL_STORAGE_STATE_PERSIST,
  reducer: (state) => {
    return state;
  },
});

export default new Vuex.Store({
  modules,
  actions: {
    resetStates,
    resetStatesVuexPersist,
  },
  state: {
    loader: false,
  },
  mutations: {
    enableLoader(state, loaderState) {
      state.loader = loaderState;
    },
  },
  plugins: [vuexPersist.plugin],
});
